import axios from 'axios';

const api = '/api/provisions';

export const getProvisions = params => {
  const queryParams = params
    ? Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&')
    : '';

  return axios.get(`${api}?${queryParams}&cacheBuster=${new Date().getTime()}`);
};

export const getById = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const create = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const evaluate = (id, data) => {
  return axios.post(`${api}/evaluate${id ? '?id=' + id + '&' : '?'}cacheBuster=${new Date().getTime()}`, data);
};

export const update = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};

export const addAgentProvision = (id, agentProvision) => {
  return axios.post(`${api}/agent-provision/${id}?cacheBuster=${new Date().getTime()}`, agentProvision);
};

export const updateAgentProvision = (id, agentProvision) => {
  return axios.put(`${api}/agent-provision/${id}?cacheBuster=${new Date().getTime()}`, agentProvision);
};

export const deleteAgentProvision = id => {
  return axios.delete(`${api}/agent-provision/${id}?cacheBuster=${new Date().getTime()}`);
};

export const deleteImportedProvision = id => {
  return axios.delete(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const regenerateSingleProvision = id => {
  return axios.get(`${api}/regenerate/${id}?cacheBuster=${new Date().getTime()}`);
};

export const regenerateNotProcessedImportedProvisions = () => {
  return axios.get(`${api}/regenerate-not-processed?cacheBuster=${new Date().getTime()}`);
};

export const getLogs = taskId => {
  return axios.get(`${api}/import/${taskId}?cacheBuster=${new Date().getTime()}`);
};

export const importProvisions = file => {
  const formData = new FormData();
  formData.append('file', file);

  return axios.post(`${api}/import`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getImportedProvisionFiles = () => {
  return axios.get(`${api}/files?cacheBuster=${new Date().getTime()}`);
};

export const deleteImportedProvisionFile = id => {
  return axios.delete(`${api}/files/${id}?cacheBuster=${new Date().getTime()}`);
};
